export default __webpack_public_path__ + "static/media/bootstrap-logo.98585727.svg";